import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Lock } from '@tink/core/src/components/atoms/Icons/Lock';
import { Circle } from '@tink/core/src/components/atoms/Circle/Circle';
import { BalancedText } from '@tink/core/src/components/atoms/BalancedText/BalancedText';
import { ProviderEntity } from '../../../../../models/provider';
import { Caption, Text } from '../../../../atoms/Text/Text';
import { messages } from './messages';
import { StyledImageContainer, StyledProviderBannerWrapper } from './ProviderBanner.styles';

type ProviderBannerProps = {
  userHintId?: string;
  provider: ProviderEntity;
};

export const ProviderBanner = ({ provider, userHintId }: ProviderBannerProps) => (
  <StyledProviderBannerWrapper>
    <StyledImageContainer>
      <Circle size="xlarge" color="primary" shade="200">
        <Lock color="primary" data-testid="lock-icon" />
      </Circle>
    </StyledImageContainer>
    <Text mb="normal" data-testid="provider-banner-message">
      <BalancedText>
        <FormattedMessage {...messages.nextStep} values={{ providerName: provider.displayName }} />
      </BalancedText>
    </Text>
    {userHintId && <Caption>{userHintId}</Caption>}
  </StyledProviderBannerWrapper>
);
